import DagNodeButton from "src/components/ui/dag/DagNodeButton";

export interface MarkdownDagNodeButtonProps {
  nodeId: string;
  dagNodes: ReadonlyArray<{
    nodeId: string;
    title: string;
    status: string;
  }>;
  selectedNodeId: string | null;
  onSelectNode: (nodeId: string) => void;
}

export function MarkdownDagNodeButton({ 
  nodeId, 
  dagNodes, 
  selectedNodeId, 
  onSelectNode
}: MarkdownDagNodeButtonProps) {
  // Find the node in the DAG
  const node = dagNodes.find(n => n.nodeId === nodeId);
  
  if (!node) {  
    return null;
  }
  
  // Create a handler for this specific node
  const handleClick = () => {
    if (node.status === "SUCCESS") {
      onSelectNode(nodeId);
    }
  };
  
  // Use the DagNodeButton component, always inline
  return (
    <DagNodeButton
      node={node}
      getNodeId={(n) => n.nodeId}
      getNodeTitle={(n) => n.title}
      getNodeStatus={(n) => n.status}
      onClick={handleClick}
      isActive={selectedNodeId === nodeId}
      isClickable={node.status === "SUCCESS"}
      inline={true}
    />
  );
}